import { MatSnackBar } from '@angular/material/snack-bar';
import { SplashPageService } from './splash-page.service';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MStarValidators } from '@morningstar/shared/validators';

@Component({
  selector: 'wsg-splash-page',
  templateUrl: './splash-page.component.html',
  styleUrls: ['./splash-page.component.css']
})
export class SplashPageComponent implements OnInit {

  contactUsForm: FormGroup;
  processing = false;
  successMessage = '';
  errorMessage = '';

  constructor(private formBuilder: FormBuilder, private splashPageService: SplashPageService, private snackbar: MatSnackBar) { }

  ngOnInit() {
    this.setForm();
  }

  setForm() {
    this.contactUsForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', MStarValidators.phone],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required]
    });
  }

  submit(formDirective: FormGroupDirective) {
    this.processing = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.splashPageService.newContactRequest(this.contactUsForm.getRawValue())
                          .subscribe(success => {
                            this.successMessage = 'Thank you for contacting us. We will reach out to you as soon as possible.';
                            this.setForm();
                            formDirective.resetForm();
                          }, error => {
                            this.snackbar.open('Error sending contact request', 'DISMISS', { duration: 3000 });
                          }, () => {
                            this.processing = false;
                          });
  }

  scrollToContactUs(contactUsForm: any) {
    contactUsForm.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }
}
